import api from './api'

export const ordersService = {
  getAll: async (params = {}) => {
    const res = await api.get('/orders/admin', { params })
    return res.data
  },

  getByOrderNumber: async (orderNumber) => {
    const res = await api.get(`/orders/${orderNumber}`)
    return res.data.data
  },

  // Admin full order detail
  adminGetDetail: async (orderNumber) => {
    const res = await api.get(`/orders/admin/${orderNumber}`)
    return res.data.data
  },

  updateStatus: async (orderNumber, status, note) => {
    const res = await api.patch(`/orders/admin/${orderNumber}/status`, { status, note })
    return res.data.data
  },

  // Manually confirm payment (COD collected early, bank transfer, etc.).
  // Same auth/CSRF pattern as updateStatus — no body.
  markPaid: async (orderNumber) => {
    const res = await api.patch(`/orders/admin/${orderNumber}/mark-paid`)
    return res.data.data
  },

  // Admin manual order creation
  create: async (data) => {
    const res = await api.post('/orders/admin', data)
    return res.data.data
  },

  // Returns
  getReturns: async (params = {}) => {
    const res = await api.get('/orders/admin/returns', { params })
    return res.data
  },

  approveReturn: async (returnId) => {
    const res = await api.patch(`/orders/admin/returns/${returnId}/approve`)
    return res.data.data
  },

  refundReturn: async (returnId) => {
    const res = await api.patch(`/orders/admin/returns/${returnId}/refund`)
    return res.data.data
  },
}
